<template>
  <div class="warpper">
    <!-- 搜索 -->
    <div style="margin-bottom: 10px">
      <el-form :model="searchForm" ref="searchForm" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="巡更路线名称" prop="title" label-width="100px">
              <el-input
                v-model="searchForm.title"
                size="medium"
                placeholder="请输入巡更路线名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button
              size="small"
              @click="onLoad(1)"
              type="primary"
              icon="el-icon-search"
              style="width: 90px; margin-left: 15px"
              >搜索</el-button
            >
            <el-button
              size="small"
              @click="restSearch"
              type="danger"
              style="width: 90px"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin: 0 20px 20px 20px">
      <el-button
        size="small"
        plain
        type="primary"
        icon="el-icon-plus"
        @click="addCharacter"
        style="width: 90px"
        >新增</el-button
      >
      <el-button
          size="small"
          type="primary"
          @click="downloadurl"
          style="width: 90px"
          >导出</el-button
        >
    </div>
    <el-table :data="list" style="width: 100%"  v-loading="isShowloading" border>
      <el-table-column prop="title" label="路线名称" align="center">
      </el-table-column>
      <el-table-column prop="sum" label="巡更点数" align="center" width="80">
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="80" :formatter="statusListShow">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="160">
      </el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="updataCharacter(scope.row)"
            >修改</el-button
          >

          <el-button @click="del(scope.row)" type="text" size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="block" style="margin-top: 15px">
      <el-pagination
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 新增模态框 -->
    <el-dialog
      :title="modalTitle"
      :close-on-click-modal="false"
      :visible.sync="isAddModal"
      width="70%"
    >
      <el-form
        ref="form"
        :model="addData"
        label-width="90px"
        :rules="addDataRules"
        label-position="center"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="路线名称" prop="title" label-width="120px">
              <el-input
                v-model="addData.title"
                placeholder="请输入路线名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status" label-width="120px">
              <el-select clearable filterable v-model="addData.status" placeholder="请选择">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="选择巡更点" prop="patrolPointList" label-width="120px">
              <div class="warp">
                <div class="left">
                  <!-- 搜索 -->
                  <div style="margin-bottom: 10px">
                    <el-form
                      :model="searchForms"
                      ref="searchForm"
                      label-width="80px"
                    >
                      <el-row>
                        <el-col :span="8">
                          <el-form-item
                            prop="name"
                            style="margin-left: 0;"
                          >
                            <el-input
                              v-model="searchForms.title"
                              size="medium"
                              placeholder="请输入巡更点名称"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-button
                            size="small"
                            @click="patrolClassList(1)"
                            type="primary"
                            icon="el-icon-search"
                            style="width: 90px; margin-left: 15px"
                            >搜索</el-button
                          >
                          <el-button
                            size="small"
                            @click="restSearchs"
                            type="danger"
                            style="width: 90px"
                            >重置</el-button
                          >
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                  <el-table
                    border
                    :data="tableData"
                    ref="table"
                    @select="handleSelect"
                    type="selection"
                    @select-all="handleSelectAll"
                    v-loading="isShowloading"
                    style="width: 100%"
                  >
                    <el-table-column type="selection" width="40">
                    </el-table-column>
                    <el-table-column prop="title" label="巡更点名称" align="center">
                    </el-table-column>
                    <el-table-column prop="patrolLevel" label="巡更点类型" align="center">
                    </el-table-column>
                    <el-table-column prop="deviceNumber" label="设备编号" align="center">
                    </el-table-column>
                    <el-table-column prop="deviceAddress" label="设备位置" align="center">
                    </el-table-column>
                  </el-table>
                  <!-- 分页器 -->
                  <div class="block" style="margin-top: 15px">
                    <el-pagination
                      align="center"
                      @size-change="handleSizeChanges"
                      @current-change="handleCurrentChanges"
                      :current-page="currentPages"
                      :page-sizes="[10, 20, 30]"
                      :page-size="pageSizes"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="totals"
                    >
                    </el-pagination>
                  </div>
                </div>
                <!-- <div class="right">
                  <div class="head">
                    已选中巡更路线(<span style="color: #409EFF;">{{ managers.length }}</span>)
                  </div>
                  <div class="xgList">
                    <div class="li" v-for="(item, ind) in managers" :key="ind">
                      <span>{{ item.name }}</span>
                      <i class="el-icon-close" @click="standardDel(item,ind)"></i>
                    </div>
                  </div>
                </div> -->
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isAddModal = false">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="btnLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      addDataRules: {
        title: [
          { required: true, message: "请输入巡更路线名称", trigger: "blur" },
        ],
        // patrolPointList: [
        //   { required: true, message: "请输入巡更点", trigger: "blur" },
        // ],
        status: [
          { required: true, message: "请选择巡更状态", trigger: "blur" },
        ],
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      currentPages: 1,
      pageSizes: 10,
      totals: 0,
      addData: {},
      statusList: [
        {
          id: 1,
          name: "启用",
        },
        {
          id: -1,
          name: "禁用",
        },
      ],
      isAddModal: false,
      btnLoading: false,
      isShowloading: false,
      modalTitle: "新增",
      managers: [],
      searchForm: {
        title:""
      },
      searchForms: {
        title:""
      },
      tableData: [],
    };
  },
  mounted() {
    this.onLoad();
  },
  watch: {
    //监听表格数据变化时回显，判断有数据时及弹窗绑定值为true时调用回显,不然会报同上问题
    tableData(newVal) {
      if (newVal.length > 0) {
        this.showSelection();
      }
    },
  },
  methods: {
    downloadurl(){
      window.location.href = process.env.VUE_APP_UPLOAD_REAL_PATH + '/export/patrolRoute?title=' + this.searchForm.title + '&villageId=' + JSON.parse(localStorage.getItem('park_data')).id
    },
    patrolClassList(e){
      let page = {
        size: this.pageSizes,
        current:e || this.currentPages,
        ...this.searchForms,
      };
      this.$Apis.patrolClassList(page).then((res) => {
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPages = current;
          this.sizes = pages;
          this.totals = total;
          this.tableData = list;
        }
      });
    },
    standardDel(item, ind) {
      this.managers.splice(ind, 1);
      this.$refs.table.clearSelection();
      // this.showSelection()
    },
    //多选
    handleSelect(selection, row) {
      //声名标记，判断已选择项数组是否存在当前选中项，若存在删除该项，不存在则添加
      let flag;
      //深拷贝已选择项，我这里是兄弟组件传值，改变原数组的话会导致还没点击确定，兄弟组件就接到了新值
      let newArr = JSON.parse(JSON.stringify(this.managers));
      newArr.forEach((item, index) => {
        if (item.id == row.id) {
          newArr.splice(index, 1);
          flag = true;
        }
      });
      if (!flag) {
        let {id,title,deviceAddress,deviceNumber,villageId,patrolLevel,patrolLevelId,patrolLevelParentId,qrCode} = row
        let patrolLevelTitle = patrolLevel.split('-')[1]
        let patrolLevelParentTitle = patrolLevel.split('-')[0]
        let type = 1
        newArr.push({ id, title,deviceAddress,deviceNumber,villageId,patrolLevelParentId,patrolLevelId,patrolLevelTitle,patrolLevelParentTitle,qrCode,type});
      }
      this.managers = newArr;
      this.addData.patrolPointList = newArr
    },  
    //全选
    handleSelectAll(selection) {
      //参数selection为当前页的选中项数组,长度大于0则为全部选中，相反为全部取消选中
      if (selection.length > 0) {
        //stateArr为暂存已选择项,深拷贝selection数组，这里是将selection元素全部添加到stateArr
        this.stateArr = JSON.parse(JSON.stringify(selection));
        //深拷贝已选中项数组，因业务需求我这里是兄弟组件传入的已选中项，
        //由于是点击确定按钮时传值不另外声名的话会导致改变managers时
        //兄弟组件监听到变化直接改变了managers数组
        let newManagers = JSON.parse(JSON.stringify(this.managers));
        selection.forEach((item) => {
          let patrolLevelTitle = item.patrolLevel.split('-')[1]
        let patrolLevelParentTitle = item.patrolLevel.split('-')[0]
        let type = 1
          newManagers.push({ id: item.id, title: item.title,villageId:item.villageId,patrolLevelParentId:item.patrolLevelParentId,patrolLevelId:item.patrolLevelId,deviceAddress:item.deviceAddress,deviceNumber:item.deviceNumber,patrolLevelTitle,patrolLevelParentTitle,type});
        });
        //数组中对象根据id去重
        var objItem = {},
          newAry = [];
        for (var i = 0; i < newManagers.length; i++) {
          if (!objItem[newManagers[i].id]) {
            newAry.push(newManagers[i]);
            objItem[newManagers[i].id] = true;
          }
        }
        this.managers = newAry;
        this.addData.patrolPointList = newAry
      } else {
        //取消全部选中的状态，此时stateArr为当前业的表格数据，用于判断取消选中的哪页数据
        this.stateArr = JSON.parse(JSON.stringify(this.tableData));
        //map方法将每项的id放 入set数组中
        var set = this.stateArr.map((item) => {
          return item.id;
        });
        //根据id过滤掉已选择项数组中存在这些id的数据
        var resArr = this.managers.filter((item) => !set.includes(item.id));
        this.managers = resArr;
        this.addData.patrolPointList = resArr
      }
    },
    //表格多选回显
    showSelection() {
      let arr = [];
      let set = this.managers.map((item) => {
        return item.id;
      });

      //过滤出已选择项和table数据中id对应上的数据，完成回显
      arr = this.tableData.filter((item) => {
        return set.includes(item.id);
      });
      this.$nextTick(() => {
        arr.forEach((item) => {
          this.$refs.table.toggleRowSelection(item);
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if(this.addData.patrolPointList.length < 1){
            this.$message.warning('请选择巡更点')
            return
          }
          let patrolPointIds = this.addData.patrolPointList.map(item=>item.id).join(',')
            var data = {
              id: this.addData.id || "",
              title: this.addData.title,
              status: this.addData.status,
              patrolPointList: this.addData.patrolPointList,
              patrolPointIds
            };
            this.btnLoading = true;
            this.$Apis.patrolRouteAddUp(data).then((res) => {
              this.btnLoading = false;
              if (res.code == 200) {
                this.isAddModal = false;
                this.onLoad();
                this.$message.success("操作成功");
              } else {
                this.$message.warning(res.msg);
              }
            });
        }
      });
    },
    // 新增
 async   addCharacter() {
  this.searchForms.title = ""
  await this.patrolClassList()
      this.isAddModal = true;
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.patrolPointList = []
      this.$nextTick(()=>{
        this.$refs.table.clearSelection()
        this.managers = []
      })
      this.modalTitle = "新增";
    },
    onLoad() {
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        ...this.searchForm,
      };
      this.isShowloading = true;
      this.$Apis.patrolRouteList(page).then(res=>{
        this.isShowloading = false;
        if(res.code == 200){
          let { current, list, pages, total } = res.data;
          list.forEach(item=>{
            item.patrolPointList = JSON.parse(item.patrolPointList)
            item.sum = item.patrolPointList.length
          })
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.list = list;
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
  async  updataCharacter(row) {
    this.searchForms.title = ""
    await this.patrolClassList()
      this.managers = row.patrolPointList
      this.addData = JSON.parse(JSON.stringify(row));
      this.modalTitle = '修改'
      this.isAddModal = true
    },
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.patrolRoutedel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    statusListShow(row){
      if(row.status == 1){
        return "启用"
      }else{
        return "禁用"
      }
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 巡更点重置按钮
    restSearchs() {
      for (let item in this.searchForms) {
        this.searchForms[item] = "";
      }
      this.patrolClassList(1);
    },    
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChanges(val) {
      this.currentPages = 1;
      this.pageSizes = val;
      this.patrolClassList();
      //   this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChanges(val) {
      this.currentPages = val;
      this.patrolClassList();
      //   this.onLoad();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding-bottom: 0;
}
.warp {
  display: flex;
  .left {
    width: 100%;
    margin-right: 10px;
    box-sizing: border-box;
  }
  .right {
    width: 28%;
    border-left: 1px solid #f5f5f5;
    padding-left: 10px;
    box-sizing: border-box;
    .xgList {
      .li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s;
        border-radius: 2px;
        &:hover {
          color: #fff;
          background: #409eff;
        }
        i {
          cursor: pointer;
        }
      }
    }
  }
}
</style>